import { render, staticRenderFns } from "./UkPrivacyPolicy.vue?vue&type=template&id=793e73b0&scoped=true"
import script from "./UkPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./UkPrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "793e73b0",
  null
  ,true
)

export default component.exports